export const SET_PAGE = 'setPage'
export const SET_MESSAGE = 'setMessage'
export const SET_PARENTS = 'setParents'
export const SET_USERS_TREE = 'setUsersTree'
export const SET_TOKEN = 'setToken'
export const CLEAR_TOKEN = 'clearToken'
